import { createSchemaPlugin } from '../../factories/createSchemaPlugin'
import { SchemaObjectNode } from './TypedNode'
import { SchemaObjectModel } from './ViewModel'

export const SchemaObjectPlugin = createSchemaPlugin(
  'Schema.Object',
  SchemaObjectModel,
  SchemaObjectNode
)
